import React from 'react'

import { Toaster } from 'react-hot-toast'
import { ToastContainer } from 'react-toastify'

import WalletPortfolioDrawer from '@src/components/WalletPortfolioDrawer'
import Background from '@src/components/icons/Background'
import { ConfigLoadingStatus } from '@src/enums'
import { useFetchAllTokens } from '@src/hooks/useFetchAllTokens'
import Footer from '@src/layouts/Footer'
import Header from '@src/layouts/Header'
import { useConfigStore } from '@src/zustand_stores'
import { useApplicationStore } from '@src/zustand_stores/application.store'

interface Props {
    children: React.ReactNode
}

const Layout: React.FC<Props> = (props: Props) => {
    const configLoading = useConfigStore(config => config.loading)
    const { isLoading: zustandTokensLoading, error: tokenLoadingError } = useFetchAllTokens()
    const { walletDrawerOpened, openWalletDrawer } = useApplicationStore()

    return (
        <>
            <div className='absolute left-0 top-0 -z-10 h-screen w-screen overflow-hidden'>
                <div className='relative h-full w-full'>
                    <Background className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2' />
                </div>
            </div>

            {/* Alert Banner */}
            {/* <div className='w-full border border-yellow-900/20 bg-yellow-900/20 p-4'>
                <div className='mx-auto flex max-w-screen-xl items-center justify-center'>
                    <p className='text-center text-xs md:text-sm text-yellow-200'>
                        We&apos;re experiencing higher than usual trading volume. Our team is working to restore full
                        service. Thank you for your patience.
                    </p>
                </div>
            </div> */}

            <Header />
            <main className='flex flex-grow flex-col items-center justify-center font-geist tracking-tightest'>
                {((): JSX.Element => {
                    if (configLoading === ConfigLoadingStatus.loading || zustandTokensLoading) {
                        return <img src='/gifs/sandwatch-loading.gif' alt='status' className='my-auto h-40' />
                    } else if (configLoading === ConfigLoadingStatus.error) {
                        console.error(`FATAL: Unable to load config from server.`)
                        return (
                            <div className='exchange-error-message my-auto text-center text-xl font-medium leading-8 text-red-700'>
                                Our trading system is currently down for maintenance. Please try again soon. [1]
                            </div>
                        )
                    } else if (tokenLoadingError) {
                        console.error(`FATAL: Unable to load list of supported tokens from server.`)
                        return (
                            <div className='exchange-error-message my-auto text-center text-xl font-medium leading-8 text-red-700'>
                                Our trading system is currently down for maintenance. Please try again soon. [2]
                            </div>
                        )
                    }
                    return <>{props.children}</>
                })()}
            </main>
            <Footer />
            <WalletPortfolioDrawer open={walletDrawerOpened} onClose={() => openWalletDrawer(false)} />
            <ToastContainer />
            <Toaster
                position='bottom-center'
                reverseOrder={false}
                gutter={8}
                containerClassName=''
                containerStyle={{}}
                toastOptions={{
                    className: '',
                    duration: 5000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                        wordBreak: 'break-word',
                    },
                    success: {
                        duration: 3000,
                    },
                }}
            />
        </>
    )
}

export default Layout
